import {useSelector} from "react-redux";
import {selectEntityData} from "state/selectors/data";

export function useNotificationStatus(id) {
    return useSelector(s=>selectEntityData(s, 'app.notification-status', id));
}